module.exports = __webpack_public_path__ + "img/martin_et_les_fees.8e1d7a07.jpg";